import React from 'react';
import PermissionGate from '../CadastroPerfilUsuario/PermissionGate';

function FornecedorFormulario ({botao, eventoTeclado, cadastrar, obj, remover, alterar}){

    return(
        <form>
            <div className="modal-form-field">
                <input 
                type="text"
                value={obj?.nomeEmpresa || ''} 
                onChange={eventoTeclado} 
                name='nomeEmpresa' 
                placeholder="Nome Empresa" 
                className='form-control' />
            </div>
            
            <div className="modal-form-field">
                <input 
                type="text"
                value={obj?.telefone || ''} 
                onChange={eventoTeclado} 
                name='telefone' 
                placeholder="Telefone" 
                className='form-control'/>
            </div>
            
            <div className="modal-form-field">
                <input 
                type="text"
                value={obj?.cnpj || ''} 
                onChange={eventoTeclado} 
                name='cnpj' 
                placeholder="CNPJ" 
                className='form-control'/>
            </div>
            
            <div className="modal-form-field">
                <input 
                type="text"
                value={obj?.email || ''} 
                onChange={eventoTeclado} 
                name='email' 
                placeholder="Email" 
                className='form-control'/>
            </div>
            
            <div className="modal-form-field">
                <input 
                type="text"
                value={obj?.endereco || ''} 
                onChange={eventoTeclado} 
                name='endereco' 
                placeholder="Endereco" 
                className='form-control'/>
            </div>

            <div className="modal-buttons">
                {
                    botao
                    ?
                    <div className="modal-actions">
                        <PermissionGate permissions={["fornecedorCadastrar"]}>
                            <button type="button" onClick={cadastrar} className='modal-button modal-button-primary'>
                                Cadastrar
                            </button>
                        </PermissionGate>
                    </div>
                    :(
                    <div className="modal-actions">
                        <PermissionGate permissions={["fornecedorAlterar"]}>
                            <button type="button" onClick={alterar} className='modal-button modal-button-warning'>
                                Alterar
                            </button>
                        </PermissionGate>

                        <PermissionGate permissions={["fornecedorRemover"]}>
                            <button type="button" onClick={remover} className='modal-button modal-button-danger'>
                                Remover
                            </button>
                        </PermissionGate>
                    </div>
                    )
                }
            </div>
        </form>
    );

}

export default FornecedorFormulario;


